// Almost redeclared default input-type node here
import { useEffect, useRef } from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    className?: string;
}

export const Input = ({
    placeholder = "Your Email",
    value,
    onChange,
    disabled = false,
    className = "",
    ...props
}: InputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (props.autoFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [props.autoFocus]);

    return (
        <div
            className={`w-80 h-11 px-4 py-1 rounded-2xl outline outline-1 outline-offset-[-1px] inline-flex justify-between items-center
                bg-white/10 outline-white/10 transition-all duration-200
                focus-within:outline-white
                ${disabled ? "opacity-50 cursor-not-allowed" : ""}
                ${className}`}
        >
            <input
                ref={inputRef}
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className={`w-full bg-transparent outline-none text-base font-normal font-outfit leading-6
                    text-white/60 placeholder:text-white/60
                    focus:text-white focus:placeholder:text-white
                    disabled:text-white/20 disabled:placeholder:text-white/20
                `}
                {...props}
            />
        </div>
    );
};
